import React, { useState, useEffect, useRef } from "react";
import { useDispatch, useSelector } from "react-redux";
import { styled } from "@mui/styles";
import makeStyles from "@mui/styles/makeStyles";
import DriveEtaIcon from "@mui/icons-material/DriveEta";
import CloseIcon from "@mui/icons-material/Close";
import { Modal, Typography, Paper, IconButton } from "@mui/material";
import ButtonBlue from "../../../shared/buttonBlue";
import {
  GoogleMap,
  Marker,
  useLoadScript,
  InfoWindow,
} from "@react-google-maps/api";
import { GoogleAPIkey } from "../../../../../../src/utils/googleMapAssets";
import MarkerDriver from "./MarkerDriver";
import SiteService from "../../../../../services/site.service";
import { getLocationAndVehicleUsage } from "../../../../../actions/locationVehicle";

const placesLibrary = ["places"];

const useStyles = makeStyles((theme) => ({
  Modal: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
  },
  Paper: {
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    width: "90%",
    height: "85%",
    padding: "20px",
  },
  partOfTitle: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    marginBottom: "20px",
    gap: "10px",
  },
  partOfTitleLeft: {
    display: "flex",
    alignItems: "center",
    gap: "10px",
    width: "100%",
  },
  IconButtonClose: {
    color: theme.palette.primary.main,
  },
  IconCar: {
    fontSize: "40px",
    marginRight: "10px",
    color: theme.palette.primary.main,
  },
  Title: {
    fontSize: "30px",
    color: theme.palette.primary.main,
    [theme.breakpoints.down("sm")]: {
      fontSize: "20px",
    },
  },
  Detail: {
    fontSize: "16px",
    color: theme.palette.primary.main,
    [theme.breakpoints.down("sm")]: {
      fontSize: "14px",
    },
  },
}));

const AlertMessage = styled("div")({
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  backgroundColor: "rgba(255, 255, 255, 0.8)",
  padding: "20px",
  borderRadius: "10px",
  boxShadow: "0 0 10px rgba(0, 0, 0, 0.5)",
  fontSize: "16px",
  color: "red",
});

const ModalShowmap = (props) => {
  const classes = useStyles();
  const dispatch = useDispatch();
  const [isLocationDriver, setLocationDriver] = useState([
    {
      Lat: props.isLocationDriver.Lat,
      Long: props.isLocationDriver.Long,
      lastUpdate: props.isLocationDriver.lastUpdate,
    },
  ]);
  const [siteFrom, setSiteFrom] = useState(null);
  const [siteTo, setSiteTo] = useState(null);
  const [deliveredPackageLocation, setDeliveredPackageLocation] =
    useState(null);
  const [fromPlace, setFromPlace] = useState(null);
  const [toPlace, setToPlace] = useState(null);
  const { user: currentUser } = useSelector((state) => state.auth);
  const locationVehicle = useSelector((state) => state.locationVehicle);

  const { isLoaded } = useLoadScript({
    id: "google-map-script",
    googleMapsApiKey: GoogleAPIkey,
    libraries: placesLibrary,
    language: "th",
    region: "TH",
  });

  const [refresh, setRefresh] = useState(false);
  const handleClick = () => {
    setRefresh((prev) => !prev);
  };

  useEffect(() => {
    if (props.inforInCar != null) {
      if (props.typeBooking === "DeliverySampleShuttleCar") {
        const fetchData = async () => {
          try {
            await dispatch(getLocationAndVehicleUsage(currentUser.idUser));
          } catch (error) {
            console.error("Failed to fetch:", error);
          }
        };
        fetchData();
      } else if (props.typeBooking === "BetweenSiteCar") {
        SiteService.getLocationDriverById(currentUser.idUser)
          .then((res) => {
            if (res.data) {
              setLocationDriver([
                {
                  Lat: res.data[0].lat,
                  Long: res.data[0].lng,
                  lastUpdate: res.data[0].lastUpdate,
                },
              ]);
            }
          })
          .catch((error) => {
            setLocationDriver([]);
          });
      } else {
        SiteService.getLocationDriverById(props.inforInCar.idDriver)
          .then((res) => {
            if (res.data) {
              setLocationDriver([
                {
                  Lat: res.data[0].lat,
                  Long: res.data[0].lng,
                  lastUpdate: res.data[0].lastUpdate,
                },
              ]);
            }
          })
          .catch((error) => {
            setLocationDriver([]);
          });
      }

      if (props.typeBooking === "DeliverySampleShuttleCar") {
        SiteService.getSitebyName(props.inforInCar.fromPlace).then((res) => {
          if (res.data) {
            setSiteFrom(res.data[0]);
          } else {
            setSiteFrom(null);
          }
        });
        SiteService.getSitebyName(props.inforInCar.toPlace).then((res) => {
          if (res.data) {
            setSiteTo(res.data[0]);
          } else {
            setSiteTo(null);
          }
        });
        if (
          (props.inforInCar.status === "ส่งสินค้าเรียบร้อย" ||
            props.inforInCar.status === "ได้รับสินค้าเรียบร้อย") &&
          props.inforInCar.deliveredLat &&
          props.inforInCar.deliveredLng
        ) {
          setDeliveredPackageLocation({
            Lat: props.inforInCar.deliveredLat,
            Long: props.inforInCar.deliveredLng,
          });
        }
      } else if (
        props.typeBooking === "BetweenSiteCar" &&
        props.inforInCar.fromPlace &&
        props.inforInCar.toPlace
      ) {
        setSiteFrom({
          Lat: props.inforInCar.fromLat,
          Long: props.inforInCar.fromLong,
        });
        setSiteTo({
          Lat: props.inforInCar.toLat,
          Long: props.inforInCar.toLong,
        });
      } else {
        const geocoder = new window.google.maps.Geocoder();
        geocoder.geocode(
          { address: props.inforInCar.fromPlace },
          (results, status) => {
            if (status === window.google.maps.GeocoderStatus.OK && results[0]) {
              setFromPlace(results[0].geometry.location); // ตำแหน่งที่ได้จาก Geocoder
            } else {
              console.error(
                "Geocode was not successful for the following reason: " + status
              );
            }
          }
        );
      }
      const geocoder = new window.google.maps.Geocoder();
      geocoder.geocode(
        { address: props.inforInCar.toPlace },
        (results, status) => {
          if (status === window.google.maps.GeocoderStatus.OK && results[0]) {
            setToPlace(results[0].geometry.location); // ตำแหน่งที่ได้จาก Geocoder
          } else {
            console.error(
              "Geocode was not successful for the following reason: " + status
            );
          }
        }
      );
    }
  }, [props.inforInCar, refresh]);

  useEffect(() => {
    if (locationVehicle && locationVehicle.result?.length > 0) {
      setLocationDriver([
        {
          Lat: locationVehicle.result[0].lat,
          Long: locationVehicle.result[0].lng,
          lastUpdate: locationVehicle.result[0].lastUpdate,
        },
      ]);
    }
  }, [locationVehicle]);

  const containerStyle = {
    width: "100%",
    height: "100%",
  };

  const isDelivered =
    props.typeBooking === "DeliverySampleShuttleCar" &&
    props.inforInCar?.status === "ส่งสินค้าเรียบร้อย" &&
    deliveredPackageLocation;

  const defaultProps = {
    center: isDelivered
      ? {
          lat: parseFloat(deliveredPackageLocation.Lat),
          lng: parseFloat(deliveredPackageLocation.Long),
        }
      : null,
    zoom: isDelivered ? 15 : null,
  };

  return (
    <>
      {isLoaded && props.inforInCar && isLocationDriver.length > 0 && (
        <Modal
          className={`${classes.Modal}`}
          open={props.open}
          onClose={props.onCloseHandle}
          aria-labelledby="simple-modal-title"
          aria-describedby="simple-modal-description"
        >
          <Paper className={`${classes.Paper}`}>
            <div className={`${classes.partOfTitle}`}>
              <div className={`${classes.partOfTitleLeft}`}>
                <DriveEtaIcon className={`${classes.IconCar}`} />
                <div
                  style={{
                    display: "flex",
                    justifyContent: "space-between",
                    width: "100%",
                    alignItems: "center",
                  }}
                >
                  <div
                    style={{
                      display: "flex",
                      flexDirection: "column",
                      alignItems: "start",
                      marginRight: "10px",
                    }}
                  >
                    <Typography className={`${classes.Title}`}>
                      แสดงแผนที่
                    </Typography>
                    {isLocationDriver.length > 0 &&
                      ((props.typeBooking === "DeliverySampleShuttleCar" &&
                        locationVehicle.result?.length > 0 &&
                        !locationVehicle.result[0]?.endTime) ||
                        (props.typeBooking === "BetweenSiteCar" &&
                          props.inforInCar.isFinish === 0)) && (
                        <Typography className={`${classes.Detail}`}>
                          {new Date(
                            isLocationDriver[0].lastUpdate
                          ).toLocaleString("th-TH", {
                            year: "numeric",
                            month: "long",
                            day: "numeric",
                            hour: "2-digit",
                            minute: "2-digit",
                          })}
                        </Typography>
                      )}
                  </div>
                  <ButtonBlue
                    variant="contained"
                    onClick={handleClick}
                    sx={{ height: "36.5px" }}
                  >
                    Refresh
                  </ButtonBlue>
                </div>
              </div>
              <IconButton
                className={`${classes.IconButtonClose}`}
                onClick={props.onCloseHandle}
              >
                <CloseIcon />
              </IconButton>
            </div>
            <div style={{ height: "90%", width: "100%" }}>
              <GoogleMap
                mapContainerStyle={containerStyle}
                center={defaultProps.center}
                zoom={defaultProps.zoom}
              >
                {props.typeBooking !== "BetweenSiteCar" ? (
                  props.typeBooking === "DeliverySampleShuttleCar" ? (
                    <>
                      <MarkerDriver
                        refresh={refresh}
                        inforInCar={props.inforInCar}
                        siteFrom={siteFrom}
                        siteTo={siteTo}
                        isLocationDriver={isLocationDriver}
                        typeBooking={props.typeBooking}
                      />
                      {(locationVehicle.result?.length <= 0 ||
                        (locationVehicle.result?.length > 0 &&
                          locationVehicle.result[0].endTime)) &&
                        props.inforInCar.status !== "ส่งสินค้าเรียบร้อย" &&
                        props.inforInCar.status !== "ได้รับสินค้าเรียบร้อย" && (
                          <AlertMessage>
                            ยังไม่ได้เชื่อมต่อรถรับส่งตัวอย่าง
                          </AlertMessage>
                        )}
                      {(props.inforInCar.status === "ส่งสินค้าเรียบร้อย" ||
                        props.inforInCar.status ===
                          "ได้รับสินค้าเรียบร้อย") && (
                        <AlertMessage style={{ color: "#2196F3" }}>
                          ส่งพัสดุเรียบร้อย <br />{" "}
                          {!deliveredPackageLocation &&
                            "ไม่พบตำแหน่งส่งพัสดุสำเร็จในระบบ"}
                        </AlertMessage>
                      )}
                    </>
                  ) : (
                    <>
                      {props.inforInCar.idDriver ? (
                        <MarkerDriver
                          refresh={refresh}
                          inforInCar={props.inforInCar}
                          siteFrom={siteFrom}
                          siteTo={siteTo}
                          isLocationDriver={isLocationDriver}
                          typeBooking={props.typeBooking}
                        />
                      ) : (
                        <AlertMessage>ไม่พบข้อมูล</AlertMessage>
                      )}
                    </>
                  )
                ) : (
                  <MarkerDriver
                    refresh={refresh}
                    inforInCar={props.inforInCar}
                    siteFrom={siteFrom}
                    siteTo={siteTo}
                    isLocationDriver={isLocationDriver}
                    typeBooking={props.typeBooking}
                  />
                )}
                {siteTo && (
                  <Marker
                    position={{
                      lat: parseFloat(siteTo.Lat),
                      lng: parseFloat(siteTo.Long),
                    }}
                    icon={{
                      url:
                        "data:image/svg+xml;charset=UTF-8," +
                        encodeURIComponent(`
                        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="#d9534f" width="56px" height="56px">
                          <path d="M12 2C8.69 2 6 4.69 6 8c0 3.53 3.87 7.61 5.47 9.19.3.3.77.3 1.06 0C14.13 15.61 18 11.53 18 8c0-3.31-2.69-6-6-6zm0 8c-1.1 0-2-.9-2-2s.9-2 2-2 2 .9 2 2-.9 2-2 2z"/>
                        </svg>
                      `),
                    }}
                    onClick={() => {
                      window.open(
                        `https://www.google.com/maps?q=${siteTo.Lat},${siteTo.Long}`,
                        "_blank"
                      );
                    }}
                  />
                )}
                {toPlace && (
                  <Marker
                    position={toPlace}
                    icon={{
                      url:
                        "data:image/svg+xml;charset=UTF-8," +
                        encodeURIComponent(`
                        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="#d9534f" width="56px" height="56px">
                          <path d="M12 2C8.69 2 6 4.69 6 8c0 3.53 3.87 7.61 5.47 9.19.3.3.77.3 1.06 0C14.13 15.61 18 11.53 18 8c0-3.31-2.69-6-6-6zm0 8c-1.1 0-2-.9-2-2s.9-2 2-2 2 .9 2 2-.9 2-2 2z"/>
                        </svg>
                      `),
                    }}
                  />
                )}
                {siteFrom && (
                  <Marker
                    position={{
                      lat: parseFloat(siteFrom.Lat),
                      lng: parseFloat(siteFrom.Long),
                    }}
                    icon={{
                      url:
                        "data:image/svg+xml;charset=UTF-8," +
                        encodeURIComponent(`
                        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="#005f40" width="56px" height="56px">
                          <path d="M12 2C8.69 2 6 4.69 6 8c0 3.53 3.87 7.61 5.47 9.19.3.3.77.3 1.06 0C14.13 15.61 18 11.53 18 8c0-3.31-2.69-6-6-6zm0 8c-1.1 0-2-.9-2-2s.9-2 2-2 2 .9 2 2-.9 2-2 2z"/>
                        </svg>
                      `),
                    }}
                    onClick={() => {
                      window.open(
                        `https://www.google.com/maps?q=${siteFrom.Lat},${siteFrom.Long}`,
                        "_blank"
                      );
                    }}
                  />
                )}
                {fromPlace && (
                  <Marker
                    position={fromPlace}
                    icon={{
                      url:
                        "data:image/svg+xml;charset=UTF-8," +
                        encodeURIComponent(`
                        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="#005f40" width="56px" height="56px">
                          <path d="M12 2C8.69 2 6 4.69 6 8c0 3.53 3.87 7.61 5.47 9.19.3.3.77.3 1.06 0C14.13 15.61 18 11.53 18 8c0-3.31-2.69-6-6-6zm0 8c-1.1 0-2-.9-2-2s.9-2 2-2 2 .9 2 2-.9 2-2 2z"/>
                        </svg>
                      `),
                    }}
                  />
                )}
                {(props.inforInCar.status === "ส่งสินค้าเรียบร้อย" ||
                  props.inforInCar.status === "ได้รับสินค้าเรียบร้อย") &&
                  deliveredPackageLocation && (
                    <Marker
                      position={{
                        lat: parseFloat(deliveredPackageLocation.Lat),
                        lng: parseFloat(deliveredPackageLocation.Long),
                      }}
                      icon={{
                        url:
                          "data:image/svg+xml;charset=UTF-8," +
                          encodeURIComponent(`
                       <svg xmlns="http://www.w3.org/2000/svg" height="24" width="24" viewBox="0 0 512 512"><!--!Font Awesome Free 6.7.2 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license/free Copyright 2025 Fonticons, Inc.--><path fill="#007bff" d="M32 32l448 0c17.7 0 32 14.3 32 32l0 32c0 17.7-14.3 32-32 32L32 128C14.3 128 0 113.7 0 96L0 64C0 46.3 14.3 32 32 32zm0 128l448 0 0 256c0 35.3-28.7 64-64 64L96 480c-35.3 0-64-28.7-64-64l0-256zm128 80c0 8.8 7.2 16 16 16l160 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-160 0c-8.8 0-16 7.2-16 16z"/></svg>
                      `),
                      }}
                      onClick={() => {
                        window.open(
                          `https://www.google.com/maps?q=${deliveredPackageLocation.Lat},${deliveredPackageLocation.Long}`,
                          "_blank"
                        );
                      }}
                    >
                      <InfoWindow
                        position={{
                          lat: parseFloat(deliveredPackageLocation.Lat),
                          lng: parseFloat(deliveredPackageLocation.Long),
                        }}
                        options={{
                          pixelOffset: new window.google.maps.Size(0, -24),
                        }}
                      >
                        <div>
                          <h3>ตำแหน่งที่ส่งพัสดุสำเร็จ</h3>
                          <p>Latitude: {deliveredPackageLocation.Lat}</p>
                          <p>Longitude: {deliveredPackageLocation.Long}</p>
                        </div>
                      </InfoWindow>
                    </Marker>
                  )}
              </GoogleMap>
            </div>
          </Paper>
        </Modal>
      )}
    </>
  );
};
export default ModalShowmap;
